(() => {
  function initProduct(root) {
    if (root.dataset.productMainInitialized) return;
    root.dataset.productMainInitialized = 'true';
    root.querySelectorAll('[data-option-group]').forEach(group => {
      const options = group.querySelectorAll('.opt');
      options.forEach(button => button.addEventListener('click', () => {
        options.forEach(option => option.classList.toggle('sel', option === button));
      }));
    });

    const form = root.querySelector('.product-form');
    if (!form) return;
    const variantsNode = form.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const variantInput = form.querySelector('[data-variant-id]');
    const sku = root.querySelector('[data-product-sku]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const submit = form.querySelector('[type="submit"]');
    const optionInputs = [...root.querySelectorAll('[data-product-option]')];
    const money = amount => {
      const currency = window.Shopify?.currency?.active || document.documentElement.getAttribute('data-currency') || 'USD';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount / 100);
    };
    const updateVariant = () => {
      const selectedOptions = optionInputs.map(input => input.value);
      const variant = variants.find(item => item.options.every((value, index) => value === selectedOptions[index])) || variants.find(item => String(item.id) === variantInput?.value);
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (sku) {
        sku.textContent = variant.sku || '—';
        sku.href = `${window.location.pathname}?variant=${variant.id}`;
      }
      if (price) price.textContent = money(variant.price);
      if (compare) {
        const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compare.hidden = !hasCompare;
        compare.textContent = hasCompare ? money(variant.compare_at_price) : '';
      }
      if (submit) submit.disabled = !variant.available;
    };
    optionInputs.forEach(input => input.addEventListener('change', updateVariant));

    const quantity = form.querySelector('[data-product-quantity]');
    root.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { if (quantity) quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    root.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { if (quantity) quantity.value = Number(quantity.value || 1) + 1; });
    updateVariant();
  }

  function boot() { document.querySelectorAll('[data-product-main]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
